<script setup lang="ts">
import { useNotificationStore } from '@/stores/notificationStore';
import { computed } from 'vue';
import Notification from './Notification.vue';

const notificationStore = useNotificationStore();
const showSnackbar = computed(() => !!notificationStore.currentPopUpMessage);
</script>

<template>
  <v-snackbar :modelValue="showSnackbar" timeout="-1" color="off-white">
    <Notification
      :value="notificationStore.currentPopUpMessage"
      @click:close="notificationStore.hidePopUpMessage()"
    />
  </v-snackbar>
</template>

<style lang="scss" scoped>
.v-snackbar:deep(.v-snackbar__content) {
  padding: unset;
}
</style>
